// lib
import PropTypes from 'prop-types'

import BaseControls from '@aytm/app/stats/page/question-views/sh/components/Controls'
import {
  BANNER_VIEW_OPTION_KEYS,
  CHART_NO_PRICE_VIEW_OPTIONS,
  CHART_VIEW_OPTIONS,
  SUBSCRIBE_VIEW_OPTION_KEYS
} from '@aytm/app/stats/page/question-views/sh/lib/constants'

const Controls = ({ showPrice, isAmazon, hasBannerProducts, hasSubscribeProducts, ...props }) => {
  let options = showPrice ? CHART_VIEW_OPTIONS : CHART_NO_PRICE_VIEW_OPTIONS

  if (!(isAmazon && hasSubscribeProducts)) {
    options = options.filter(opt => !SUBSCRIBE_VIEW_OPTION_KEYS.includes(opt.value))
  }

  if (!hasBannerProducts) {
    options = options.filter(opt => !BANNER_VIEW_OPTION_KEYS.includes(opt.value))
  }

  return <BaseControls type="product-metrics" options={options} {...props} />
}

const { type, ...propTypes } = BaseControls.propTypes

Controls.propTypes = {
  ...propTypes,
  showPrice: PropTypes.bool,
  isAmazon: PropTypes.bool,
  hasBannerProducts: PropTypes.bool,
  hasSubscribeProducts: PropTypes.bool
}

Controls.displayName = 'Controls'

export default Controls
